import React from "react";

const Maintenance = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Scheduled Maintenance</h1>
      <p style={styles.text}>
        Our services are currently undergoing scheduled maintenance. <br />
        We apologize for any inconvenience.
      </p>
      <p style={styles.time}>Maintenance Window: 01:00 - 02:00 March 21, 2025 (UTC)</p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa", // 밝고 깔끔한 배경
    color: "#333", // 차분한 다크 그레이 텍스트
    fontFamily: "'Georgia', serif", // 격식 있어 보이는 폰트
    textAlign: "center",
    padding: "20px",
  },
  title: {
    fontSize: "2.2rem",
    fontWeight: "bold",
    letterSpacing: "0.5px",
    marginBottom: "15px",
  },
  text: {
    fontSize: "1.3rem",
    letterSpacing: "0.2px",
    marginBottom: "10px",
    maxWidth: "600px",
    lineHeight: "1.5",
  },
  time: {
    fontSize: "1.1rem",
    fontWeight: "500",
    color: "#555",
    marginTop: "10px",
  },
};

export default Maintenance;
